import React from 'react';
import { OTSService } from '../components/LearnEarn/OTSService';
import useSEO from '../utils/useSEO';

export default function OTSServicePage() {
  useSEO({
    title: 'On-The-Spot (OTS) Assignment Service — Pay Per Page | AGO Innovations',
    description:
      'Need a single assignment done quickly? AGO Innovations OTS (On-The-Spot) service offers assignment writing at ₹3.50 per page. No subscription needed — pay per page.',
    keywords:
      'on the spot assignment help, pay per page assignment, single assignment service, OTS service AGO, assignment help India',
    canonical: 'https://agoinnovations.in/learn/customer-work/ots',
  });

  return <OTSService />;
}